import React from 'react';

/**
 * Single source of truth for status colour across Test Review, the Variables
 * tab and the test charts. Softer fills are opacity on these tokens, never a
 * second hex value — that is how three greens ended up in the product.
 */
export const STATUS = {
  good: '#1DC75D',
  warning: '#F59F0A',
  poor: '#EF4545',
  trending: '#3B82F6',
  pause: '#F97316',
  neutral: '#868E96',
} as const;

/** Chart series colours, matching the Aggregated Report. */
export const CHART = {
  control: '#2C65BE',
  variation: '#2EBE69',
  // Reuses the existing neutral token rather than introducing a fourth hex.
  neutral: STATUS.neutral,
  controlTint: '#D0DFF4',
  variationTint: '#D1F4E0',
} as const;

/** rgba() form of a token, for opacity variants. */
export const withAlpha = (hex: string, alpha: number) => {
  const h = hex.replace('#', '');
  const n = parseInt(h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
};

/**
 * An HTML dot rather than an emoji. Emoji are drawn by the OS, so the same
 * status rendered a different shade in every browser and never matched the
 * palette. This renders the exact token everywhere.
 */
export function StatusDot(
  { color, size = 10, mr = 6 }: { color: string; size?: number; mr?: number },
) {
  return (
    <span
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: mr,
        verticalAlign: 'middle',
        flex: 'none',
      }}
    />
  );
}
